import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_bev_3: FaireProductEntity = {
  token: "nyc-bev-3",
  type: "product",
  name: "Craft Cold Brew Coffee",
  brandName: "Brooklyn Roasters",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5014e60de379b84682b4e7ab84b3ebc84f56a11f4ed37efb6b78e49753b0514b.webp",
  priceDollars: 6,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/5014e60de379b84682b4e7ab84b3ebc84f56a11f4ed37efb6b78e49753b0514b.webp",
  weight: 1.5,
  dimensions: {
    width: 3,
    height: 9,
    depth: 3,
  },
  description: "Premium sparkling water with NYC flair",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "sparkling"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
